<script>
//SingleList.vue

export default {
    props: {
        facetTitle: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        limitOptions: {
            type: Number,
            required: true
        },
        value: {
            type: String | Number,
        },
        filterOptions: {
            type: Boolean,
            default: false,
        },
        activeFacet: {
            type: Boolean,
            default: true,
        },
        showCounts: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            id: _.uniqueId(),
            search: '',
            userCollapsed: false,
            cntVisibleOptions: this.limitOptions,
            selectedValue: this.value ?? null,

        }
    },
    created() {

    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue ?? null;
        },
        selectedValue(value) {
            this.$emit('input', value);
        },
    },
    methods: {
        reset() {
            this.search = null;
        },
        isInt(value) {
            return !isNaN(value) &&
                parseInt(Number(value)) === value &&
                !isNaN(parseInt(value, 10));
        }
    },
    computed: {
        facetKey() {
            return this.$vnode.key;
        },
        filteredList() {
            if (this.search) {
                return this.activeOptions.filter(option => {
                    return option.text.toLowerCase().includes(this.search.toLowerCase()
                    )
                })
            } else {
                return this.activeOptions;
            }
        },
        optionsCount() {
            return this.options ? this.options.length : 0;
        },
        activeOptions() {
            if (typeof this.value !== 'undefined') {
                let activeOption = this.options.filter(element => element.value == this.selectedValue);
                let otherOptions = this.options.filter(element => element.value != this.selectedValue);

                if ((activeOption.length === 0 && this.selectedValue !== null) && !this.isInt(parseInt(this.selectedValue))){
                   activeOption = [{
                            'value': this.selectedValue,
                            'text': this.selectedValue + " (0)",
                            'text_without_count':  this.selectedValue,
                            'count': 0
                    }];
                }
                return activeOption.concat(otherOptions);
            } else {
                return this.options;
            }
        }
    },
}
</script>

<template>
    <div>
        <div class="singleList">
            <div v-if="activeFacet">
                <div v-if="filterOptions" class="search-wrapper">
                    <div class="input-group">
                        <input type="text" v-model="search" :placeholder="'Suche Option...'" class="form-control"/>

                        <span class="input-group-addon">
                                    <button @click="reset()" class="btn btn-outline btn-xs" type="button"><i
                                        class="fa fa-eraser"></i></button>
                                </span>
                    </div>
                </div>
                <div>
                    <div class="radio">
                        <label :for="'all'+id"><input type="radio"
                                                      :id="'all'+id"
                                                      :name="'facet_name_'+id"
                                                      :value="null"
                                                      v-model="selectedValue"
                        >
                            <span class="allselect">Alle</span> </label>
                    </div>
                    <transition-group name="flip-list" tag="div">
                    <div class="form-group" v-bind:key="item.value" v-for="(item, index) in filteredList"
                         v-if="options && optionsCount > 0 && index < cntVisibleOptions">
                        <div class="radio">
                            <label :for="id + '_' + item.value">
                                <input type="radio"
                                       :id="id + '_' + item.value"
                                       :name="'facet_name_'+id"
                                       :value="item.value"
                                       v-model="selectedValue">
                                {{ item.text }}
                            </label>
                        </div>
                    </div>
                    </transition-group>
                    <div class="btn-group btn-group-justified" role="group" aria-label="plusminus">
                        <div class="btn-group" role="group">
                            <button class="btn btn-default btn-xs" v-if="cntVisibleOptions > limitOptions"
                                    @click="cntVisibleOptions -= limitOptions">
                                <i class="fa fa-minus"></i> weniger
                            </button>
                        </div>
                        <div class="btn-group" role="group">
                            <button class="btn btn-default btn-xs" v-if="optionsCount > cntVisibleOptions"
                                    @click="cntVisibleOptions += limitOptions">
                                <i class="fa fa-plus"></i> mehr
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style >
.flip-list-move {
    transition: transform .75s;
}

.input-group-addon {
    padding: 5px 10px;
    border: 0;
}

.input-group-addon button i {
    color: #c4c4c4;
}

.allselect {
    font-weight: bold;
    font-style: italic;
    color: #7a797b;
}

.search-wrapper {
    margin-top: 8px;
}

.singleList {
    padding: 4px;
    margin: 0;
}

.singleList input[type='radio']:after {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: #f1f1f1;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 1px solid #7a797b;
}

.singleList input[type='radio']:checked:after {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: #a39577;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 1px solid #7a797b;
}

</style>
